import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=420fb6f6&scoped=true&"
import script from "./Notices.vue?vue&type=script&lang=ts&"
export * from "./Notices.vue?vue&type=script&lang=ts&"
import style0 from "./Notices.vue?vue&type=style&index=0&id=420fb6f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420fb6f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
